import script from "./customer-map.vue?vue&type=script&lang=ts&setup=true"
export * from "./customer-map.vue?vue&type=script&lang=ts&setup=true"

import "./customer-map.vue?vue&type=style&index=0&id=0bfa4453&lang=scss&scoped=true"

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bfa4453"]])

export default __exports__